import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { defaultLayout } from "./layouts";

// Route Views
import Landing from './components/Views/Landing';
import Nodes from './components/Views/Nodes';
import Providers from './components/Views/Providers';
import Validators from './components/Views/Validators';
import Blockchain from './components/Views/Blockchain';
import BlockchainDetails from './components/Views/BlockchainDetails';
import Governance from './components/Views/Governance';
import Market from './components/Views/Market';
import Utilities from './components/Views/Utilities';
import Dvpnnodes from './components/Views/Dvpnnodes';
import DvpnnodesCountry from "./components/Views/DvpnnodesCountry";
import DvpnnodesDetails from "./components/Views/DvpnnodesDetails";
import CountryDvpnnodesList from "./components/Views/CountryDvpnnodesList";
import ValidatorsList from './components/Views/ValidatorsList';
import ValidatorsDetails from "./components/Views/ValidatorsDetails";
import UtilitiesDapp from "./components/Views/Utilitiesdapp";

export default [
  {
    path: "/",
    exact: true,
    layout: defaultLayout,
    component: () => <Redirect to="/home" />
  },
  {
    path: "/home",
    exact: true,
    layout: defaultLayout,
    component: Landing
  },
  {
    path: "/nodes",
    layout: defaultLayout,
    component: Nodes
  },
  {
    path: "/providers",
    layout: defaultLayout,
    component: Providers
  },
  {
    path: "/validators",
    layout: defaultLayout,
    component: Validators
  },
  {
    path: "/blockchain",
    layout: defaultLayout,
    component: Blockchain
  },
  {
    path: "/blockchain-details",
    layout: defaultLayout,
    component: BlockchainDetails
  },
  {
    path: "/governance",
    layout: defaultLayout,
    component: Governance
  },
  {
    path: "/market",
    layout: defaultLayout,
    component: Market
  },
  {
    path: "/utilities",
    layout: defaultLayout,
    component: Utilities
  },
  {
    path: "/countries",
    layout: defaultLayout,
    component: DvpnnodesCountry
  },
  {
    path: "/nodelist",
    layout: defaultLayout,
    component: CountryDvpnnodesList
  },
  {
    path: "/dvpnnodes",
    layout: defaultLayout,
    component: Dvpnnodes
  },
  {
    path: "/dvpnnodes-details",
    layout: defaultLayout,
    component: DvpnnodesDetails
  },
  {
    path: "/validatorlist",
    layout: defaultLayout,
    component: ValidatorsList
  },
  {
    path: "/validatordetails",
    layout: defaultLayout,
    component: ValidatorsDetails
  },
  {
    path: "/uilitiesdapp",
    layout: defaultLayout,
    component: UtilitiesDapp
  },
];